import { render } from "./ReviewNoteModal.vue?vue&type=template&id=573bb5c5&ts=true"
import script from "./ReviewNoteModal.vue?vue&type=script&lang=ts"
export * from "./ReviewNoteModal.vue?vue&type=script&lang=ts"

import "./ReviewNoteModal.vue?vue&type=style&index=0&id=573bb5c5&lang=scss"

import exportComponent from "/home/meiyeer/irb-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__